/**
 * @fileoverview gRPC-Web generated client stub for admpb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.14.0
// source: proto/admpb/disclosure.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var proto_commonpb_file_pb = require('../../proto/commonpb/file_pb.js')

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')
const proto = {};
proto.admpb = require('./disclosure_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.admpb.DisclosureServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.admpb.DisclosureServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.admpb.DownloadBlankReportRequest,
 *   !proto.commonpb.File>}
 */
const methodDescriptor_DisclosureService_DownloadBlankReport = new grpc.web.MethodDescriptor(
  '/admpb.DisclosureService/DownloadBlankReport',
  grpc.web.MethodType.UNARY,
  proto.admpb.DownloadBlankReportRequest,
  proto_commonpb_file_pb.File,
  /**
   * @param {!proto.admpb.DownloadBlankReportRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto_commonpb_file_pb.File.deserializeBinary
);


/**
 * @param {!proto.admpb.DownloadBlankReportRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.commonpb.File)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.commonpb.File>|undefined}
 *     The XHR Node Readable Stream
 */
proto.admpb.DisclosureServiceClient.prototype.downloadBlankReport =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/admpb.DisclosureService/DownloadBlankReport',
      request,
      metadata || {},
      methodDescriptor_DisclosureService_DownloadBlankReport,
      callback);
};


/**
 * @param {!proto.admpb.DownloadBlankReportRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.commonpb.File>}
 *     Promise that resolves to the response
 */
proto.admpb.DisclosureServicePromiseClient.prototype.downloadBlankReport =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/admpb.DisclosureService/DownloadBlankReport',
      request,
      metadata || {},
      methodDescriptor_DisclosureService_DownloadBlankReport);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.admpb.GetClientNoticeDisclosureResponse>}
 */
const methodDescriptor_DisclosureService_GetClientNoticeDisclosure = new grpc.web.MethodDescriptor(
  '/admpb.DisclosureService/GetClientNoticeDisclosure',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.admpb.GetClientNoticeDisclosureResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.GetClientNoticeDisclosureResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.admpb.GetClientNoticeDisclosureResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.admpb.GetClientNoticeDisclosureResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.admpb.DisclosureServiceClient.prototype.getClientNoticeDisclosure =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/admpb.DisclosureService/GetClientNoticeDisclosure',
      request,
      metadata || {},
      methodDescriptor_DisclosureService_GetClientNoticeDisclosure,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.admpb.GetClientNoticeDisclosureResponse>}
 *     Promise that resolves to the response
 */
proto.admpb.DisclosureServicePromiseClient.prototype.getClientNoticeDisclosure =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/admpb.DisclosureService/GetClientNoticeDisclosure',
      request,
      metadata || {},
      methodDescriptor_DisclosureService_GetClientNoticeDisclosure);
};


module.exports = proto.admpb;

